export const UNRESOLVED_LOAN_ACTIVATION_EXISTS = 'UNRESOLVED_LOAN_ACTIVATION_EXISTS';

export const UNRESOLVED_LOAN_ACTIVATION_PROFILE_MESSAGE =
  'Ya existe una venta registrada pendiente de resolución. No es posible iniciar una nueva operación en este momento.';

export const isUnresolvedLoanActivation = (creditInfo) =>
  creditInfo?.code === UNRESOLVED_LOAN_ACTIVATION_EXISTS;

export const resolveCreditAvailability = (creditInfo, effectiveLimits = { total: 0, available: 0 }) => {
  if (isUnresolvedLoanActivation(creditInfo)) {
    return {
      isUnresolved: true,
      status: 'REJECTED',
      code: creditInfo.code,
      total_limit: 0,
      available_credit: 0,
      product_limits: null,
    };
  }

  const resolved = {
    isUnresolved: false,
    status: creditInfo?.status,
    code: typeof creditInfo?.code === 'string' ? creditInfo.code : null,
    total_limit: effectiveLimits?.total ?? 0,
    available_credit: effectiveLimits?.available ?? 0,
  };

  if (creditInfo && Object.prototype.hasOwnProperty.call(creditInfo, 'product_limits')) {
    resolved.product_limits = creditInfo.product_limits || null;
  }

  return resolved;
};

export const mergeCreditAvailability = (prevData, creditInfo, effectiveLimits) => {
  const availability = resolveCreditAvailability(creditInfo, effectiveLimits);
  const next = {
    ...(prevData || {}),
    total_limit: availability.total_limit,
    available_credit: availability.available_credit,
    status: availability.status ?? prevData?.status,
    code: availability.code,
  };

  if (Object.prototype.hasOwnProperty.call(availability, 'product_limits')) {
    next.product_limits = availability.product_limits;
  }

  return next;
};

export const blockFurtherSalesLocally = (prevData) =>
  mergeCreditAvailability(
    prevData,
    {
      status: 'REJECTED',
      code: UNRESOLVED_LOAN_ACTIVATION_EXISTS,
      product_limits: null,
    },
    { total: 0, available: 0 }
  );
